/**
 * 商品枠の画像の解決 (docs/features/banner-layout-template-plan.md §17)。
 *
 * 商品枠は特定の素材でなく「選択中の画像の imageIndex 番目」(既定 0) を指す。選択済み素材を差し替えると、入口のサムネイル・
 * エディタ・生成 (BE banner_layout/prompt.py resolve_effective_elements) とも自動で新しい画像になる。
 * 旧データ (段階1のテンプレート等) に残る assetId は、その素材が今も選択中なら優先する (BE と同じ規則)。
 */
import type { BannerLayoutElement } from './types';

export type LayoutImage = { id: string; thumbUrl: string };

/** 商品枠に入る画像 (無ければ undefined = 生成時にこの枠は外れる) */
export function resolveProductImage(el: BannerLayoutElement, images: LayoutImage[]): LayoutImage | undefined {
  if (el.kind !== 'product') return undefined;
  if (el.assetId) {
    const fixed = images.find((img) => img.id === el.assetId);
    if (fixed) return fixed;
  }
  return images[el.imageIndex ?? 0];
}

/** 商品枠が指す「何枚目か」(0始まり)。assetId が選択中ならその位置 */
export function productImageIndex(el: BannerLayoutElement, images: LayoutImage[]): number {
  if (el.assetId) {
    const i = images.findIndex((img) => img.id === el.assetId);
    if (i >= 0) return i;
  }
  return el.imageIndex ?? 0;
}

/** 「何枚目か」を指す形にする (固定の assetId は書かない)。0 は持たない */
export function withImageIndex(el: BannerLayoutElement, index: number): BannerLayoutElement {
  const { assetId: _assetId, imageIndex: _imageIndex, ...rest } = el;
  return index > 0 ? { ...rest, imageIndex: index } : rest;
}

/** 読み込み (プリセット / テンプレート / 再利用) で、旧データの assetId を「何枚目か」に置き換える */
export function toIndexedProducts(elements: BannerLayoutElement[], images: LayoutImage[]): BannerLayoutElement[] {
  return elements.map((el) => (el.kind === 'product' && el.assetId ? withImageIndex(el, productImageIndex(el, images)) : el));
}
